import { createSelector } from "@reduxjs/toolkit";

import { CaseDetailState } from "../reducers/caseDetailReducer";
import { StainsState } from "../reducers/frontLoaderReducers";
import { sortBlocks } from "../utils/blockUtils";
import { sortSlides } from "../utils/slideUtils";
import { sortSpecimens } from "../utils/specimenUtils";

type AppState = {
  caseDetail: CaseDetailState;
  stains: StainsState;
};

export const selectSortedCaseDetailSpecimens = createSelector(
  [({ caseDetail }: AppState) => caseDetail.specimens],
  sortSpecimens
);

export const selectSortedCaseDetailBlocks = createSelector(
  [
    selectSortedCaseDetailSpecimens,
    ({ caseDetail }: AppState) => caseDetail.blocks,
  ],
  (sortedSpecimens, blocks) => sortBlocks(blocks || [], sortedSpecimens)
);

export const selectSortedCaseDetailSlides = createSelector(
  [
    selectSortedCaseDetailBlocks,
    selectSortedCaseDetailSpecimens,
    ({ caseDetail }: AppState) => caseDetail.slides,
    ({ stains }: AppState) => stains,
  ],
  (sortedBlocks, sortedSpecimens, slides, stains) =>
    sortSlides(slides || [], sortedBlocks, sortedSpecimens, stains)
);

export const selectSortedCaseDetail = createSelector(
  [
    selectSortedCaseDetailSpecimens,
    selectSortedCaseDetailBlocks,
    selectSortedCaseDetailSlides,
    ({ caseDetail }: AppState) => caseDetail,
  ],
  (sortedSpecimens, sortedBlocks, sortedSlides, caseDetail) => {
    return {
      ...caseDetail,
      specimens: sortedSpecimens,
      blocks: sortedBlocks,
      slides: sortedSlides,
    };
  }
);

export default selectSortedCaseDetail;
